import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  fetchDashboard,
  fetchVisibility,
  selectDataDashboard,
  selectDataSynch,
  selectDataVisibility,
  selectEndDateDashboard,
  selectLoading,
  selectLoading2,
  selectStartDateDashboard,
} from "./company/companySlice";
import { LayoutSplashScreen } from "../../_metronic/layout";

import Select from "react-select";
import { defaultDate } from "../utility";

export const VisibilityPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const data = useSelector(selectDataVisibility);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(
        fetchVisibility({
          start_date: defaultDate,
          end_date: defaultDate,
          type: "sales_summary",
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Visibility">
        <CardHeaderToolbar>
          <Button
            className="btn btn-secondary mr-3"
            onClick={() => history.goBack()}
          >
            <i className="fa fa-arrow-left"></i>Back
          </Button>
        </CardHeaderToolbar>
      </CardHeader>{" "}
      <CardBody>
        {/* Filter */}
        <Form className="mb-5">
          <Form.Group as={Row}>
            <Col sm={6}></Col>
            <Col sm={6}></Col>
          </Form.Group>
        </Form>
      </CardBody>
    </Card>
  );
};
